export type CanonicalPaymentMethod = 'pix' | 'debit' | 'credit';

export const PAYMENT_METHOD_FILTER_OPTIONS: { value: CanonicalPaymentMethod; label: string }[] = [
  { value: 'pix', label: 'PIX' },
  { value: 'debit', label: 'Débito' },
  { value: 'credit', label: 'Crédito' },
];

export function canonicalPaymentMethod(raw?: string | null): CanonicalPaymentMethod | null {
  const value = String(raw || '').trim().toLowerCase();
  if (!value || value === 'pagar.me' || value === 'pagarme') return null;
  if (value === 'pix') return 'pix';
  if (
    value === 'debit_card' ||
    value === 'debit' ||
    value.includes('débito') ||
    value.includes('debito') ||
    value.includes('debit')
  ) {
    return 'debit';
  }
  if (
    value === 'credit_card' ||
    value === 'credit' ||
    value.includes('crédito') ||
    value.includes('credito') ||
    value.includes('credit') ||
    ['visa', 'master', 'mastercard', 'amex', 'elo', 'hipercard'].includes(value)
  ) {
    return 'credit';
  }
  return null;
}

export function paymentMethodDisplay(raw?: string | null): string {
  const canonical = canonicalPaymentMethod(raw);
  if (canonical === 'pix') return 'PIX';
  if (canonical === 'debit') return 'Débito';
  if (canonical === 'credit') return 'Crédito';
  return '—';
}
